import * as GETTERS from '@/store/constants/getters.js';

export const getters = {
    [GETTERS.ACTIVE_WORKSPACES](state, getters) {
        return Object.keys(state.active_workspaces)
            .map((workspace) => ({
                ...state.active_workspaces[workspace],
                ...getters[GETTERS.WORKSPACE_BY_UUID](workspace),
                outstanding_items: aggregateOutstandingItems(workspace, getters),
            }));
    },
    [GETTERS.ACTIVE_QUICK_SEARCHES](state, getters) {
        return Object.keys(state.active_quick_searches)
            .map((quick_search) => ({
                ...state.active_quick_searches[quick_search],
                ...getters[GETTERS.QUICK_SEARCH_BY_HASH](quick_search),
            }));
    },
};

const aggregateOutstandingItems = (workspace, getters) => {
    const queues = getters[GETTERS.WORKSPACE_BY_UUID](workspace).queues;
    return queues.reduce((acc, queue) => acc + queue.outstanding_items, 0);
};
